import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import Header from 'layout/Header';
import Sidebar from 'layout/sidebar/Sidebar';

const Default = () => (
  <>
    <Header />
    <main className={'main'}>
      <Sidebar />
      <Suspense>
        <Outlet />
      </Suspense>
    </main>
  </>
);

export default Default;
